import React from 'react';

function ContactUs() {
  return (
    <div className="container max-w-4xl mx-auto">
      <div className="px-10 pt-10 pb-10">
        <h1 className="text-3xl text-center font-semibold mb-8">Contact Us</h1>
        <p className="text-center">
          Need a refresher or have any questions? Our help center is just a click away.
        </p>
        <h1 className="text-3xl font-semibold mb-1 mt-8">Our Address</h1>
        <p className="font-semibold text-lg">Racetime India</p>
        <p>A Block Brigade Gateway</p>
        <p>26/1 Dr Rajkumar Road</p>
        <p>Malleshwaram West</p>
        <p>Bangalore 560055</p>
        <p className="mt-3">
          Email: <b>team@racetime.in</b>
        </p>
        <p className="mt-0">
          Phone: <b>+91-9844092027</b>
        </p>
      </div>
    </div>
  );
}

export default ContactUs;
